import React, { useState } from 'react';
import { Avatar, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import moment from 'moment';
import 'moment/locale/ru';
import { purpleB, primaryB, secondaryC } from 'constants/colors';
import Link from '@material-ui/core/Link';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles({
  blink: {
    animation: '$blinkEffect 1.5s linear infinite',
  },
  '@keyframes blinkEffect': {
    '50%': {
      backgroundColor: secondaryC,
    },
  },
});

const HistoryComments = ({ comments, setReply, CW, cardHeight, showAllComments, setShowAllComments }) => {
  const classes = useStyles();
  const [photos, setPhotos] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [sIndex, setSIndex] = useState(0);
  const [blink, setBlink] = useState();

  const moreComments = () => {
    setShowAllComments(true);
  };

  const hideComments = () => {
    setShowAllComments(false);
    window.scrollTo(0, cardHeight.current.offsetTop);
  };

  const goToComment = (id) => {
    window.scrollTo(0, document.getElementById('comment_' + id).getBoundingClientRect().top + window.pageYOffset - 300);
    setBlink(id);
    setTimeout(() => {
      setBlink();
    }, 3000);
  };

  const chooseReply = (id) => {
    setReply(id);
    window.scrollTo(0, cardHeight.current.offsetTop + cardHeight.current.offsetHeight - 300);
  };

  const handleLightBox = (state, sIndex, photos) => {
    if (photos.length !== 0 && photos.length > sIndex) {
      setToggle(state);
      setSIndex(sIndex);
      setPhotos(photos);
    }
  };

  return (
    <Grid item container direction={'column'} justify={'center'} spacing={2} xs={12} md={12} style={{ padding: 8, marginLeft: 0 }}>
      {!!comments?.length ? (
        comments.slice(0, showAllComments ? comments.length : 2).map((comment, i) => (
          <Grid
            className={blink === comment?.id && classes.blink}
            item
            container
            xs={12}
            md={12}
            direction={'row'}
            justify={'flex-start'}
            alignItems={'center'}
            style={{ marginBottom: '20px' }}
            id={'comment_' + comment?.id}
          >
            <Grid item container xs={12} md={12} style={{ marginBottom: 8 }}>
              <Grid item>
                <Avatar src={comment?.userPhoto || '/broken-image.jpg'} style={{ width: '28px', height: '28px', marginRight: '8px', background: '#7f56d9' }} />
              </Grid>
              <Grid item>
                <Typography variant='subtitle2' color={'primary'} style={{ marginTop: 4, marginRight: 8, fontWeight: 600 }}>
                  {comment?.createdByFullname}
                </Typography>
              </Grid>
            </Grid>
            {!!comment?.replyId && !!comments?.find((c) => c?.id === comment?.replyId) && (
              <Grid
                item
                xs={12}
                md={12}
                container
                onClick={() => goToComment(comment?.replyId)}
                direction={'row'}
                alignItems={'center'}
                justifyContent={'flex-start'}
                style={{ backgroundColor: purpleB, padding: 8, cursor: 'pointer' }}
              >
                <Divider orientation='vertical' flexItem style={{ backgroundColor: primaryB, marginLeft: 8, marginRight: 8, width: 2 }} />
                <Grid item xs={11}>
                  <Grid item container xs={12} md={12}>
                    <Grid item>
                      <Avatar src='/broken-image.jpg' style={{ width: '28px', height: '28px', marginRight: '8px', background: '#7f56d9' }} />
                    </Grid>
                    <Grid item>
                      <Typography variant='subtitle2' color={'primary'} style={{ marginTop: 4, marginRight: 8, fontWeight: 600 }}>
                        {comments?.find((c) => c?.id === comment?.replyId)?.createdByFullname}
                      </Typography>
                    </Grid>
                  </Grid>
                  {!!comments?.find((c) => c?.id === comment?.replyId)?.attachments?.length && (
                    <Grid item xs={12} md={12}>
                      <Typography variant='caption' style={{ color: primaryB, fontWeight: 500, marginLeft: 8 }}>
                        Вложение
                      </Typography>
                    </Grid>
                  )}
                  {!!comments?.find((c) => c?.id === comment?.replyId)?.text && (
                    <>
                      <Grid item container direction={'row'} xs={12} md={12}>
                        <Typography variant='subtitle2' style={{ fontWeight: 500, marginLeft: 8 }}>
                          <Typography>{comments?.find((c) => c?.id === comment?.replyId)?.text}</Typography>
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            )}
            {!!comment?.attachments?.length && (
              <Grid xs={12} item container direction={'row'} alignItems={'flex-start'} justifyContent={'flex-start'} spacing={2}>
                {comment?.attachments?.map((link, i, p) =>
                  !!(link.slice(-3) === 'png' || link.slice(-4) === 'jpeg' || link.slice(-3) === 'jpg' || link.slice(-3) === 'gif' || link.slice(-4) === 'webp') ? (
                    <Grid item>
                      <Avatar
                        variant='rounded'
                        alt='img'
                        src={link}
                        style={{ width: CW > 1030 ? 295 : '21vw', height: CW > 1030 ? 295 : '21vw', border: '1px solid ' + purpleB, borderRadius: 10 }}
                        onClick={(e) => handleLightBox(true, i, p)}
                      />
                    </Grid>
                  ) : (
                    <Grid item>
                      <Link href={link} target='_blank'>
                        <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-start'} spacing={1}>
                          <Grid item>
                            <CloudDownloadIcon style={{ width: '32px', height: '32px', color: primaryB }} />
                          </Grid>
                          <Grid item>
                            <Typography variant={'subtitle1'} style={{ fontWeight: 500, textAlign: 'center', color: primaryB }}>
                              Скачать файл
                            </Typography>
                          </Grid>
                        </Grid>
                      </Link>
                    </Grid>
                  )
                )}
              </Grid>
            )}
            {!!comment?.text && (
              <>
                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{
                    whiteSpace: 'pre-wrap',
                    marginTop: 4,
                    marginLeft: 8,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.875rem',
                    fontFamily: 'Inter',
                    lineHeight: 1.57,
                  }}
                >
                  <Typography>{comment?.text}</Typography>
                </Grid>
              </>
            )}
            <Grid item container direction={'row'} justifyContent={'space-between'} alignItems={'center'} xs={12} style={{ marginTop: 8 }}>
              <Grid item>
                <Typography
                  variant='caption'
                  onClick={() => chooseReply(comment?.id)}
                  style={{ color: primaryB, fontWeight: 500, marginLeft: 4, cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Ответить
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='caption' style={{ color: '#888', fontWeight: 700, marginRight: 4 }}>
                  {moment(comment?.createdDate).format('HH:mm')}
                </Typography>
                <Typography variant='caption' style={{ color: '#aaa', fontWeight: 500, marginLeft: 4 }}>
                  {moment(comment?.createdDate).format('DD MMMM YYYY')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))
      ) : (
        <Grid item>
          <Typography variant={'body2'} style={{ color: '#ccc', textAlign: 'center' }}>
            {'Здесь пока нет комментариев'}
          </Typography>
        </Grid>
      )}
      {comments.length > 2 && !showAllComments && (
        <Grid item>
          <Typography variant={'body2'} color={'primary'} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={moreComments}>
            {'Показать еще'}
          </Typography>
        </Grid>
      )}
      {comments.length > 2 && showAllComments && (
        <Grid item>
          <Typography variant='body2' color='primary' style={{ textAlign: 'center', cursor: 'pointer' }} onClick={hideComments}>
            Скрыть
          </Typography>
        </Grid>
      )}
      {!!toggle && (
        <Lightbox
          mainSrc={photos[sIndex]}
          imageCaption={sIndex + 1 + '/' + photos.length}
          nextSrc={photos[(sIndex + 1) % photos.length]}
          prevSrc={photos[(sIndex + photos.length - 1) % photos.length]}
          onCloseRequest={() => {
            setToggle(false);
            setSIndex(0);
          }}
          onMovePrevRequest={() => setSIndex((sIndex + photos.length - 1) % photos.length)}
          onMoveNextRequest={() => setSIndex((sIndex + 1) % photos.length)}
        />
      )}
    </Grid>
  );
};

export default HistoryComments;
